import HttpStatus from 'ha/constants/HttpStatus';
import {
  TOO_LARGE_FILE_ERROR,
  MaxFileSizeMBHumanized,
} from 'ha/constants/files';

import { sendFileAction } from './actions';

export default ({ file, conversationId }, T) => (dispatch, _, { apiV2 }) => {
  dispatch(sendFileAction.start());

  return apiV2
    .sendTalkPageFile({ file, conversationId })
    .then(({ data: { messages } }) => {
      const lastMessage = messages[0];

      dispatch(sendFileAction.done(lastMessage));
    })
    .catch(error => {
      if (error.code === HttpStatus.ENTITY_TOO_LARGE) {
        dispatch(
          sendFileAction.error({
            message: T(TOO_LARGE_FILE_ERROR, MaxFileSizeMBHumanized),
          }),
        );
      } else {
        dispatch(sendFileAction.error(error));
      }
    });
};
